/**
 * price-cap.js — Plafond de prix (Shopify Payments)
 * -------------------------------------------------------------------------
 * Empêche, côté client, l'ajout au panier de toute variante dont le prix est
 * supérieur ou égal au plafond défini dans les réglages du thème
 * (Réglages → « Plafond de prix »). Source de vérité unique :
 * window.wpbingo.settings.priceCap (injecté par snippets/header-javascript.liquid).
 *
 * Trois niveaux de protection :
 *   1. Réévaluation à chaque changement de variante (événement `variantChange`
 *      déclenché par wpbingo.Variants) : bouton « Ajouter au panier » désactivé
 *      (état seulement, le contenu n'est jamais modifié), paiement express masqué,
 *      délai de livraison remplacé par le message (.price-cap-message).
 *   2. Interception de la soumission du formulaire en phase CAPTURE : garantit
 *      qu'aucune variante au-dessus du plafond ne part au panier, même si
 *      l'attribut `disabled` a été retiré (ajax/itemAddedCallback) ou trafiqué.
 *   3. Re-application après chaque requête ajax (itemAddedCallback retire
 *      `disabled` sur TOUS les `.btn--add-to-cart` après un ajout).
 *
 * Le rendu serveur (Liquid) gère l'état initial ; ce module gère la dynamique.
 * Dépendance : jQuery (déjà chargé par header-javascript.liquid).
 */
(function ($) {
  'use strict';

  if (!$) { return; }

  var cfg = (window.wpbingo && wpbingo.settings && wpbingo.settings.priceCap) || null;
  if (!cfg || !cfg.enabled) { return; }

  var CAP = parseInt(cfg.maxCents, 10);
  if (!CAP || isNaN(CAP)) { return; }

  // Carte id de variante -> { price (cents), available }, construite depuis le
  // JSON produit exposé par sections/product-template.liquid (#ProductJson-*).
  var MAP = {};

  function buildPriceMap() {
    var map = {};
    var nodes = document.querySelectorAll('script[id^="ProductJson-"]');
    for (var i = 0; i < nodes.length; i++) {
      try {
        var data = JSON.parse(nodes[i].textContent);
        if (data && data.variants && data.variants.length) {
          for (var j = 0; j < data.variants.length; j++) {
            var v = data.variants[j];
            map[String(v.id)] = { price: v.price, available: v.available };
          }
        }
      } catch (e) { /* JSON absent ou invalide : on retombe sur data-price */ }
    }
    return map;
  }

  function overCap(cents) {
    return typeof cents === 'number' && !isNaN(cents) && cents >= CAP;
  }

  // Id de la variante actuellement sélectionnée dans un formulaire produit.
  function currentId(form) {
    if (!form) { return null; }
    var el = form.querySelector('[name="id"]');
    return el ? el.value : null;
  }

  // Prix (cents) d'une variante : d'abord la carte JSON, sinon le data-price de
  // l'option sélectionnée dans le formulaire (secours autonome par formulaire).
  function priceForId(id, form) {
    if (id && MAP[id] && typeof MAP[id].price === 'number') {
      return MAP[id].price;
    }
    if (form) {
      var sel = form.querySelector('select[name="id"]');
      if (sel && sel.options[sel.selectedIndex]) {
        var dp = sel.options[sel.selectedIndex].getAttribute('data-price');
        if (dp !== null && dp !== '') { return parseInt(dp, 10); }
      }
    }
    return NaN;
  }

  // Applique l'état visuel sur un conteneur (.product-single ou .sticky-cart-single).
  function applyScope(scope, isOver, available) {
    if (!scope) { return; }
    var $scope = $(scope);

    var $btn = $scope.find('.btn--add-to-cart');
    if ($btn.length) {
      if (isOver) {
        // État seulement : on ne touche jamais à .btn__text.
        $btn.attr('disabled', 'disabled').addClass('is-price-capped');
      } else {
        $btn.removeClass('is-price-capped');
        // Ne pas réactiver une variante indisponible (gérée par ailleurs).
        if (available !== false) { $btn.removeAttr('disabled'); }
      }
    }

    // Paiement express : masqué au-dessus du plafond (s'il a été rendu).
    $scope.find('.shopify-payment-button').prop('hidden', !!isOver);
    // Délai de livraison <-> message de contact. Le message réutilise la classe
    // .estimated_delivery (pour le style) : on l'exclut du basculement « vraie
    // livraison » via .not('.price-cap-message') pour ne pas masquer les deux.
    $scope.find('.estimated_delivery').not('.price-cap-message').prop('hidden', !!isOver);
    $scope.find('.price-cap-message').prop('hidden', !isOver);
  }

  function apply(priceCents, available) {
    var isOver = overCap(priceCents);
    applyScope(document.querySelector('.product-single'), isOver, available);
    applyScope(document.querySelector('.sticky-cart-single'), isOver, available);
  }

  // Recalcule l'état à partir de la variante actuellement sélectionnée.
  function reapply() {
    var form = document.querySelector('.product-single [data-product-form]') ||
               document.querySelector('[data-product-form]');
    var id = currentId(form);
    var info = MAP[id] || null;
    apply(info ? info.price : priceForId(id, form), info ? info.available : true);
  }

  function init() {
    MAP = buildPriceMap();

    // État initial.
    reapply();

    // Réévaluation à chaque changement de variante. L'événement `variantChange`
    // est déclenché par wpbingo.Variants sur son conteneur et remonte jusqu'au
    // document ; il porte la variante sélectionnée.
    $(document).on('variantChange', function (e) {
      if (!e || !e.variant) { return; }
      apply(e.variant.price, e.variant.available);
    });

    // itemAddedCallback fait removeAttr("disabled") sur tous les .btn--add-to-cart
    // après un ajout : on réapplique l'état après chaque requête ajax.
    $(document).ajaxComplete(function () { reapply(); });
  }

  // Interception de la soumission (phase CAPTURE → s'exécute avant le handler
  // délégué jQuery du thème sur [data-product-form]). Garantit le blocage même
  // si l'attribut `disabled` a été retiré ou contourné.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !$(form).is('[data-product-form]')) { return; }
    var id = currentId(form);
    var price = priceForId(id, form);
    if (overCap(price)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      apply(price, true); // garde-fou visuel
    }
  }, true);

  // `defer` garantit le DOM prêt, mais on protège le cas d'un chargement précoce.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})(window.jQuery);
